module.exports = __webpack_public_path__ + "static/media/bROOBEE-BNB.17c7e6a7.svg";